"use client";

import React from "react";
import HeaderV1 from "./HeaderV1";
import HeaderV2Container from "./v2/HeaderV2Container";

interface HeaderFactoryProps {
  showTopBar?: number;
  showPromotional?: number;
}

export default function HeaderFactory({
  showTopBar = 1,
  showPromotional = 0,
}: HeaderFactoryProps) {
  // Read header version selection from environment variable
  const activeVersion = process.env.NEXT_PUBLIC_HEADER_VERSION || "v1";

  switch (activeVersion) {
    case "v2":
      return (
        <HeaderV2Container
          showTopBar={showTopBar}
          showPromotional={showPromotional}
        />
      );
    case "v1":
    default:
      return (
        <HeaderV1
          showTopBar={showTopBar}
          showPromotional={showPromotional}
        />
      );
  }
}
